/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IClinicalDictionary } from 'app/shared/model/clinical-dictionary.model';
import { IClinicalDictionaryType } from 'app/shared/model/clinical-dictionary-type.model';

export interface IRxCalculatorFormula {
  id?: string;
  name?: string;
  description?: string | null;
  formulaString?: string;
  entityId?: string;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  conceptId?: string;
  category?: IClinicalDictionary | null;
  categoryType?: IClinicalDictionaryType | null;
  entityType?: IClinicalDictionary | null;
}

export const defaultValue: Readonly<IRxCalculatorFormula> = {
  active: false,
};
